"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCreator = void 0;
var analytics_layer_1 = require("@pmi/analytics-layer");
var audioPlay_1 = require("./audioPlay");
var audioPause_1 = require("./audioPause");
var audioComplete_1 = require("./audioComplete");
var audio25_1 = require("./audio25");
var audio50_1 = require("./audio50");
var audio75_1 = require("./audio75");
var creatorMappings = (_a = {},
    _a[analytics_layer_1.AudioEventNames.AudioPlay] = audioPlay_1.audioPlay,
    _a[analytics_layer_1.AudioEventNames.AudioPause] = audioPause_1.audioPause,
    _a[analytics_layer_1.AudioEventNames.AudioComplete] = audioComplete_1.audioComplete,
    _a[analytics_layer_1.AudioEventNames.Audio25] = audio25_1.audio25,
    _a[analytics_layer_1.AudioEventNames.Audio50] = audio50_1.audio50,
    _a[analytics_layer_1.AudioEventNames.Audio75] = audio75_1.audio75,
    _a);
var getCreator = function (eventName) { return creatorMappings[eventName]; };
exports.getCreator = getCreator;
